import industryroundtables_background from "../images/industryroundtables/industryroundtables_background.png";
import industryroundtables1 from "../images/industryroundtables/industryroundtables1.png";
import '../invitations/Invitation.css'

const industryroundtablesInvitationElements = [

  // 🖼 IMAGE
  {
    id: 14,
    type: "image",
    src: industryroundtables1,
    x: 35,
    y: 50,
    width: 535,
    height: 400
  },

  // 🌌 BACKGROUND
  {
    id: 13,
    type: "background",
    src: industryroundtables_background,
    x: 0,
    y: 0,
    width: 595,
    height: 842
  },

  // 🎊 TOP ICONS
  {
    id: 1,
    type: "text",
    text: "🏢",
    x: 120,
    y: 25,
    fontSize: 20,
    fontFamily: "Poppins",
    fill: "#c28220"
  },
  {
    id: 2,
    type: "text",
    text: "✨",
    x: 430,
    y: 25,
    fontSize: 20,
    fontFamily: "Poppins",
    fill: "#c28220"
  },

  // ✨ TAGLINE
  {
    id: 3,
    type: "text",
    text: "Connect • Discuss • Innovate",
    x: 190,
    y: 70,
    fontSize: 18,
    fontFamily: "Great Vibes",
    fill: "#c28220"
  },

  // 🎯 MAIN TITLE
  {
    id: 4,
    type: "text",
    text: "INDUSTRY ROUNDTABLE",
    x: 160,
    y: 25,
    fontSize: 22,
    fontFamily: "Playfair Display",
    fill: "#c28220"
  },

  // ✨ DIVIDER
  {
    id: 5,
    type: "text",
    text: "──────── ✦ ────────",
    x: 190,
    y: 90,
    fontSize: 15,
    fontFamily: "Poppins",
    fill: "#c28220"
  },

  // 📝 DESCRIPTION
  {
    id: 6,
    type: "text",
    text: "Join industry leaders for insightful discussions and strategic networking",
    x: 70,
    y: 470,
    fontSize: 13,
    fontFamily: "Poppins",
    fill: "#c28220"
  },

  // 📅 DATE
  {
    id: 7,
    type: "text",
    text: "📅 Date: 12 September 2026",
    x: 180,
    y: 530,
    fontSize: 18,
    fontFamily: "Poppins",
    fill: "#c28220"
  },

  // ⏰ TIME
  {
    id: 8,
    type: "text",
    text: "⏰ Time: 10:00 AM",
    x: 210,
    y: 560,
    fontSize: 18,
    fontFamily: "Poppins",
    fill: "#c28220"
  },

  // 📍 VENUE TITLE
  {
    id: 9,
    type: "text",
    text: "📍 Venue:",
    x: 250,
    y: 610,
    fontSize: 20,
    fontFamily: "Playfair Display",
    fill: "#c28220"
  },

  // 📍 VENUE DETAILS
  {
    id: 10,
    type: "text",
    text: "Business Convention Hall",
    x: 200,
    y: 640,
    fontSize: 16,
    fontFamily: "Poppins",
    fill: "#c28220"
  },

  {
    id: 11,
    type: "text",
    text: "Vijayawada",
    x: 260,
    y: 670,
    fontSize: 18,
    fontFamily: "Poppins",
    fill: "#c28220"
  },

  // 🏁 FOOTER
  {
    id: 12,
    type: "text",
    text: "Shaping the Future Together",
    x: 170,
    y: 740,
    fontSize: 28,
    fontFamily: "Great Vibes",
    fill: "#c28220"
  }

];

export default industryroundtablesInvitationElements;